import { ButtonRounded } from "components/layout/Button/ButtonRounded";
import styled, { css } from "styled-components";

export const ButtonContainer = styled.div`
	position: relative;
	display: flex;
	flex-wrap: wrap;
	margin-top: 1rem;
	justify-content: flex-end;
	z-index: 9;

	button {
		margin-left: 0.5rem;
	}

	${({ customMarginRight }) =>
		customMarginRight &&
		css`
			margin-right: ${customMarginRight}!important;
		`}

	${({ absolute }) =>
		absolute &&
		css`
			margin: 0;
			overflow: hidden;
			position: absolute;
			right: -1px;
			bottom: -1px;
			min-height: 2.5rem;

			button {
				height: 33px;
				margin-top: 1px;
				margin-left: 0;
				svg {
					vertical-align: text-bottom;
				}
			}

			button:last-child {
				height: 35px;
				z-index: 30;
				margin-top: 0;
			}
		`}

	${({ disabled }) =>
		disabled &&
		css`
			pointer-events: none;
		`}
`;

export const Button = ({ ...props }) => (
	<ButtonRounded noBoxShadow iconSize="1.25rem" {...props} />
);
